import { css } from 'lit';

import token from '../../utils/get-token';
import color from '../../utils/get-color-token';
import { disabled, m, on, p, transition, typography } from '../../styles';

function styles() {
	return css`
		:host {
			--m-button-background-color: transparent;
			--m-button-base-size: ${token('global-height-default')};
			--m-button-border-color: ${color('color-neutral-90')};
			--m-button-border-radius: ${token('border-radius-s')};
			--m-button-color: ${color('color-text-secondary')};
			--m-button-outline-color: ${color('color-primary-100')};
			--m-button-outline-offset: 2px;
			--m-button-padding-x: ${token('spacing-4')};
			--m-button-padding-y: ${token('spacing-3')};
			/**
			 * Useful when overriding via host :slotted query.
			 */
			--m-button-font-size: ${token('font-size-3')};
		}

		.button {
			${transition([
				{ property: 'color' },
				{ property: 'background-color' },
				{ property: 'border-color' },
			])};

			${typography('button-md')};
			font-size: var(--m-button-font-size);

			cursor: pointer;
			position: relative;

			display: inline-flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;

			block-size: var(--m-button-base-size);
			box-sizing: border-box;

			text-decoration: none;

			gap: ${token('spacing-1')};

			padding-inline: var(--m-button-padding-x);
			padding-block: var(--m-button-padding-y);

			background-color: var(--m-button-background-color);
			color: var(--m-button-color);
			border: 1px solid var(--m-button-border-color);

			border-radius: var(--m-button-border-radius);
		}

		${disabled('.button')} {
			cursor: default;
		}

		${disabled('.button', '*')} {
			pointer-events: none;
		}

		${on.focus('.button')} {
			outline: 1px solid var(--m-button-outline-color);
			outline-offset: var(--m-button-outline-offset);
		}

		${on.hover('.button')} {
			--m-button-background-color: ${color('color-background-inverted')};
			--m-button-border-color: ${color('color-background-inverted')};
			--m-button-color: ${color('color-text-inverted')};
		}

		::slotted(*) {
			display: inline-flex;
			align-items: center;

			${p(0)};
			${m(0)};
		}

		slot[name='leading']::slotted(span),
		slot[name='trailing']::slotted(span) {
			justify-content: center;
		}
	`;
}

export default styles;
